import { render, staticRenderFns } from "./AddCourseFaculty.vue?vue&type=template&id=4983fafa&scoped=true&"
import script from "./AddCourseFaculty.vue?vue&type=script&lang=js&"
export * from "./AddCourseFaculty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4983fafa",
  null
  
)

export default component.exports